import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : '16px')};
    line-height: 26px;
    color: ${(props) => props.color || SEMANTIC_COLORS.SECONDARY_LINK};
    text-decoration-line: underline;
    cursor: pointer;
  `,
};
